import { Dispatch, SetStateAction, useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';

import { parseImages } from './parseImages';

interface IUseContentImagesParams {
  canParse: boolean;
  canRender: boolean;
  postContent: string;
  setPostContent: Dispatch<SetStateAction<string>>;
  done(): void;
  options?: Record<string, boolean>;
}

/**
 * Рендерит и управляет Блоками эксперта
 */
export const useContentImages = ({ canParse, postContent, setPostContent, done, options }: IUseContentImagesParams) => {
  const { pathname } = useLocation();
  const [prevPathname, setPrevPathname] = useState(pathname);
  const [isParsed, setIsParsed] = useState(false);

  /** Сбрасывает стэйт при клиентском переходе с поста на пост */
  useEffect(() => {
    if (pathname !== prevPathname) {
      setPrevPathname(pathname);
      setIsParsed(false);
    }
  }, [pathname, prevPathname]);

  /** Парсит параметры */
  useEffect(() => {
    if (!canParse || isParsed) {
      return;
    }

    if (options?.isEnabled) {
      const { items, html } = parseImages(postContent, () => '');

      if (items.length) {
        setPostContent(html);
      }
    }

    setIsParsed(true);
    done();
  }, [canParse, done, isParsed, options?.isEnabled, postContent, setPostContent]);
};
